
export default {
  props: {
    // The ID of the Variable DFP post
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data () {
    return {
      dfpPost: null,
    };
  },
  computed: {
    dfpData () {
      // membershipField comes from the auth mixin
      if (this.dfpPost && this.membershipField) {
        const reqDfp = this.dfpPost[this.membershipField];

        // Return the requested DFP script or fallback to the default
        const dfpData = (reqDfp?.slotId && reqDfp?.elementId)
          ? this.dfpPost[this.membershipField]
          : this.dfpPost.default;
        ;

        return {
          ...dfpData,
          width: this.dfpPost.width,
          height: this.dfpPost.height,
        };
      }
      return null;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getDFPPost();
    });
  },
  methods: {
    async getDFPPost () {
      const params = {
        fields: `acf`,
        posts: {
          posts_per_page: 1,
          post_type: [`variable_dfp`],
          post_status: `publish`,
          p: this.id,
        },
      };
      const request = await this.$getPosts(`/posts`, params);
      if (request !== null) {
        this.dfpPost = request[0].acf;
      }
    },
  },
};
